import React from 'react';
import PageSpinner from './PageSpinner';

export default function RouteFallback({ message = 'Loading page...' }: { message?: string }) {
  return <PageSpinner message={message} />;
}
